import { Component } from "react";
import * as Sentry from "@sentry/react";
import { Button, Result } from "antd";

// App-wide React error boundary. Catches render-time exceptions from any
// descendant, reports them to Sentry, and shows a non-broken fallback UI so
// the user can recover with a single click instead of staring at a blank
// page.
//
// IMPORTANT: this only catches render errors. Async errors (promise
// rejections, event handlers) still need their own try/catch or
// `Sentry.captureException`.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, eventId: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const eventId = Sentry.captureException(error, { extra: errorInfo });
    this.setState({ eventId });
  }

  handleReset = () => {
    this.setState({ hasError: false, eventId: null });
    window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <Result
        status="500"
        title="Something went wrong"
        subTitle="Our team has been notified. Try reloading the page; if it keeps happening, let us know and quote the reference below."
        extra={[
          <Button type="primary" key="reload" onClick={this.handleReset}>
            Reload
          </Button>,
          this.state.eventId && (
            <span key="ref" style={{ display: "block", marginTop: 12, color: "#888" }}>
              Reference: {this.state.eventId}
            </span>
          ),
        ]}
      />
    );
  }
}

export default ErrorBoundary;
